import React from 'react';
import Select from 'react-select';

class Combo extends React.Component {
	constructor(props) {
		super(props);
		this.state = this._buildState(props);
	}

	// Public API
	setValue = (value) => {
		this._handleChange(value);
	}

	getValue = () => {
		return this.state.value;
	}

	clear = () => {
		this._handleChange(null);
	}

	focus = () => {
		this._input.focus();
	}

	select = () => {
		this._input.select();
	}

	flag = (status) => {
		if (!status)
			this.setState((prevState) => {
				return { className: prevState.className + " invalid-field" }
			});
		else
			this.setState((prevState) => {
				return { className: prevState.className.replace("invalid-field", "") }
			});
	}

	validate = () => {
		return null;
	}

	completed = () => {
		return !((this.state.value === "" || this.state.value === null) && this.props.required)
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_buildState = (props) => {
		let state =
		{
			className: this._className(),
			value: props.value,
			text: props.text,
			options: this._getOptions(props.items)
		};

		// If a value is coming in (either at ctor or when updating props), but no text...
		// then look for the text label on the items, to show on the dropdown as well.
		if (props.text === undefined || props.text === null || props.text === "") {
			const option = state.options.filter(o => { return o.value === props.value });
			const text = option.length > 0 ? option[0].label : "";

			state = {
				...state,
				className: this._className(),
				value: props.value,
				text: props.text || text
			}
		}

		return state;
	}

	_getOptions = (items) => {
		// It's an array coming, return that one..
		if (items instanceof Array)
			return items;

		let options = [];

		for (var c in items)
			options.push({ value: c, label: items[c] });

		return options;
	}

	_className = () => {
		if (this.props.className !== undefined)
			return this.props.className;
		else
			return "";
	}

	_handleChange = (item) => {
		const me = this;
		let value = null;
		let label = null;

		if (item !== null) {
			value = item.value;
			label = item.label;
		}

		// In this case, we don't use update (can't remember why)
		this.setState({
			value: value,
			text: label
		}, function () {
			const requiredPassed = this.completed();
			const validationPassed = (this.validate() === null);

			const status = requiredPassed && validationPassed;

			this.flag(status);
			this.onDirt();

			// Update value field in form
			if (me.props.managed) {
				if (!me.props.label)
					this.props.onFieldChange(value, this.props.name, function () { me.onChange(item); });
				else
					this.props.onFieldAndLabelChange(value, label, me.props.name, this.props.label, function () { me.onChange(item); });
			}
			else {
				this.onChange(item);
			}
		});
	}

	// React
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.items !== this.props.items
			|| nextProps.disabled !== this.props.disabled
			|| nextState.value !== this.state.value
			|| nextState.className !== this.state.className);
	}

	componentWillReceiveProps(nextProps, nextState) {
		if (nextProps.value !== this.props.value
			|| nextProps.items !== this.props.items)
			this.setState(this._buildState(nextProps));
	}

	render() {
		let value = {
			value: this.state.value,
			label: this.state.text
		};

		// Empty string or null selections? Then leave NULL so the place holder appears...
		if ((value.value === "" || value.value === null || value.value === undefined) &&
			(value.label === "" || value.label === null || value.label === undefined))
			value = null;

		const props = {
			id: this.props.id,
			name: this.props.name,
			value: value,
			onChange: this._handleChange,
			placeholder: this.props.placeholder,
			options: this.state.options,
			className: this.state.className,
			menuStyle: { height: this.props.menuHeight },
			isDisabled: this.props.disabled,
			isSearchable: this.props.searchable,
			isClearable: this.props.clearable,
			formatGroupLabel: this.props.formatGroupLabel || null
		};

		const customStyles = {
			container: (base, state) => {
				if (!state.isDisabled)
					return {
						...base,
						backgroundColor: "transparent"
					}
				else
					return {
						...base,
						backgroundColor: "#eee"
			}},
			singleValue: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#555"
			}),
			placeholder: (provided, state) => ({
				...provided,
				top: "9px",
				color: "#AAA"
			}),
			input: (provided, state) => ({
				...provided,
				marginTop: -2,
				margin: 0,
				paddingBottom: 0,
				paddingTop: 0
			}),
			indicatorSeparator: (provided, state) => ({
				...provided,
				width: 0
			}),
			indicatorsContainer: (provided, state) => ({
				...provided,
				cursor: 'pointer'
			}),
			control: (provided, state) => ({
				...provided,
				height: 34,
				minHeight: 34,
				boxShadow: 0,
				borderRadius: 0
			}),
			menu: (provided, state) => ({
				...provided,
				marginTop: 0,
				zIndex: "999 !important",
				top: this.props.dropUp ? "auto !important" : "100%",
				bottom: this.props.dropUp ? "100% !important" : "auto",
			}),
			noOptionsMessage: (provided, state) => ({
				...provided,
				marginLeft: 0,
				height: 20,
				padding: 0,
				marging: 0
			}),
			dropdownIndicator: (base, state) => ({
				...base,
				width: '30px'
			}),
			clearIndicator: (base, state) => ({
				...base,
				width: '30px',
				marginRight: '-15px'
			}),
			menuContainerStyle: () => ({
				zIndex: "999 !important"
			})
		}

		return (
			<Select {...props}
				styles={customStyles}
				ref={(select) => { this.select = select; }} />)

	}
}

// Mark this as a form component
Combo.defaultProps = {
	formControl: true,
	managed: false,
	clearable: false,
	dropUp: false
};

export default Combo;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/combo/Combo.js